import ReactMarkdown, { type Components } from "react-markdown"
import remarkGfm from "remark-gfm"
import rehypeRaw from "rehype-raw"
import { MermaidDiagram } from "@/components/MermaidDiagram"

interface MarkdownRendererProps {
  content: string
}

function extractText(children: React.ReactNode): string {
  if (typeof children === "string") return children
  if (Array.isArray(children)) return children.map(extractText).join("")
  return ""
}

const components: Components = {
  code(props) {
    const { className, children } = props
    const match = /language-(\w+)/.exec(className ?? "")
    const language = match?.[1]

    if (language === "mermaid") {
      return <MermaidDiagram code={extractText(children).trim()} />
    }

    return <code className={className}>{children}</code>
  },
  a(props) {
    return <a {...props} target="_blank" rel="noopener noreferrer" />
  },
}

export function MarkdownRenderer({ content }: MarkdownRendererProps): JSX.Element {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]}
      components={components}
    >
      {content}
    </ReactMarkdown>
  )
}
